import { render, staticRenderFns } from "./RelatorioSinteticoAnaliticoPublicoAlvo.vue?vue&type=template&id=2467c81d&scoped=true"
import script from "./RelatorioSinteticoAnaliticoPublicoAlvo.vue?vue&type=script&lang=js"
export * from "./RelatorioSinteticoAnaliticoPublicoAlvo.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSinteticoAnaliticoPublicoAlvo.vue?vue&type=style&index=0&id=2467c81d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467c81d",
  null
  
)

export default component.exports